// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__opdM3","container":"SectionFaq_container__GNSot","faq__title":"SectionFaq_faq__title__TTXVV","faq__list-container":"SectionFaq_faq__list-container__3x2tq"};